import { useEffect, useState } from "preact/hooks";

export type PhotoFetcher = (media_ref: string) => Promise<Blob | null>;

const IMAGE_MIMES = new Set([
  "image/gif",
  "image/heic",
  "image/heif",
  "image/jpeg",
  "image/png",
  "image/webp",
]);

export function AuthenticatedPhoto({
  mediaRef,
  alt,
  testid,
  fetchPhoto,
  className,
}: {
  mediaRef: string;
  alt: string;
  testid: string;
  fetchPhoto?: PhotoFetcher;
  className: string;
}) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    setUrl(null);
    if (!fetchPhoto || typeof URL.createObjectURL !== "function") return;
    let cancelled = false;
    let made: string | null = null;
    void fetchPhoto(mediaRef)
      .then((blob) => {
        if (cancelled || blob === null || !IMAGE_MIMES.has(blob.type.toLowerCase())) return;
        made = URL.createObjectURL(blob);
        setUrl(made);
      })
      .catch(() => {
        // The row's text remains authoritative; a failed image must not break it.
      });
    return () => {
      cancelled = true;
      if (made !== null && typeof URL.revokeObjectURL === "function") URL.revokeObjectURL(made);
    };
  }, [fetchPhoto, mediaRef]);

  return url === null ? null : <img class={className} data-testid={testid} src={url} alt={alt} />;
}
